module.exports = __webpack_public_path__ + "static/img/img_orderDetail.c00ab98d.png";